import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface SignLogisticsState extends ListState<any> {
   
}

class BackSignLogistics extends ListMutations<any>{

}
class SignLogistics extends ListModule<SignLogisticsState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,

    }
    actions = {
        async getAll(context: ActionContext<SignLogisticsState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Logistics/GetSignForLogisticsList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async exportExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetSignLogisticsExport', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '已签收快递.xlsx'
            
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        }
    };
    mutations = {
        setCurrentPage(state: SignLogisticsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SignLogisticsState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}





const signlogisticslist = new SignLogistics();
export default signlogisticslist;